import { ROLE } from '@maxpreps/shared/constants/authentication';
import { resizeMascotImage } from '@maxpreps/shared/functions/utils/resizeImage';
import RoleIconName from '@maxpreps/shared/ui/Icon/RoleIconName';
import styled from 'styled-components';
import { equals } from '../../../functions/primitiveHelpers/stringHelpers';
import ListItem, { getFallbackColor, IconType } from './ListItem';

const StyledRolesList = styled.ul`
  padding: 0;
  margin: 0;
`;

const CUSTOM_ICON_ROLES = [
  {
    roleId: ROLE.standardAdmin,
    iconId: RoleIconName.StandardAdmin
  },
  {
    roleId: ROLE.photographer,
    iconId: RoleIconName.Photographer
  },
  {
    roleId: ROLE.writer,
    iconId: RoleIconName.Writer
  },
  {
    roleId: ROLE.statSupplier,
    iconId: RoleIconName.StatSupplier
  },
  {
    roleId: ROLE.associationAdministrator,
    iconId: RoleIconName.AssociationAdmin
  },
  {
    roleId: ROLE.tournamentDirector,
    iconId: RoleIconName.TournamentDirector
  },
  {
    roleId: ROLE.meetManager,
    iconId: RoleIconName.MeetManagerTrackAndField // Arbitrarily default to track (swim is ignored)
  }
];

const isSwim = (iconId, subHeader) =>
  iconId === RoleIconName.MeetManagerTrackAndField &&
  subHeader?.toUpperCase().includes('SWIM');

const getIconId = roleId =>
  CUSTOM_ICON_ROLES.find(i => equals(i.roleId, roleId))?.iconId;

// Works for both roles and favorite careers
const getListItems = (roles: undefined | any[], type: IconType) => {
  const iconSize = 40;

  return roles?.map(r => {
    let {
      photoUrl,
      roleId,
      personId,
      header,
      subHeader,
      link,
      schoolColor1,
      schoolColor2,
      schoolColor3
    } = r;

    let iconId = getIconId(roleId);

    if (isSwim(iconId, r.subHeader)) {
      iconId = RoleIconName.MeetManagerSwimming;
    }

    if (!iconId) {
      photoUrl = resizeMascotImage(photoUrl, null, iconSize, iconSize);
    }

    return (
      <ListItem
        type={type}
        iconId={iconId?.toString() || ''}
        iconName={header}
        iconUrl={photoUrl}
        iconSize={iconSize}
        key={personId}
        header={r.header}
        subheader={subHeader}
        href={link}
        fallbackColor={getFallbackColor(
          schoolColor1,
          schoolColor2,
          schoolColor3
        )}
      />
    );
  });
};

const AdminList: React.FC<{ roles: undefined | any[] }> = ({ roles }) => (
  <StyledRolesList>
    {getListItems(roles, IconType.Role)}
    {getListItems(
      roles?.filter(r => equals(r.roleId, ROLE.career)),
      IconType.Career
    )}
  </StyledRolesList>
);
export default AdminList;
